import { text } from '@fortawesome/fontawesome-svg-core'
import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    commentListItem: {
      padding: '0px 20px',
      margin: 20
    },
    userItem: {
      marginBottom: 10,
      textAlign: 'left',
      fontWeight: 'bold'
    },
    descriptionItem: {
      textAlign: 'left',
      marginBottom: 20
    },
    dateItem: {
      textAlign: 'left',
      color: 'gray',
      marginBottom: 20
    },

    Box: {
      marginBottom: 10
    },
    // DropZoneContent: {
    //   marginTop: theme.spacing(2),
    // },
    // AttachCardHeader: {
    //   color: theme.palette.primary.main,
    // },
    Buttons: {
      columnGap: theme.spacing(1),
      marginBottom: theme.spacing(1)
      //textAlign: "end",
    },
    ButtonModal: {
      marginLeft: 'auto'
    },
    fabIcon: {
      width: '30px',
      height: '30px',
      fontSize: '30px',
      marginRight: 5
    },
    fabLabel: {
      padding: '0 6px 0 4px',
      fontWeight: 500,
      fontSize: '1.0em'
    },
    fabExtended: {
      justifyContent: 'flex-start',
      alignSelf: 'flex-start',
      width: 'auto',
      zIndex: theme && theme.zIndex.drawer,
      boxShadow: '0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149)',
      backgroundColor: '#fff',
      textTransform: 'none',
      marginLeft: 10,
      color: 'default',
      // position: 'absolute',
      // bottom: 'auto',
      // right: 'auto',
      // top: '14px',
      // left: '12px',
      '&:hover': {
        boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)',
        backgroundColor: '#fff'
      }
    },
    Modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      backgroundColor: '#fff',
      border: '1px solid #e8e8e8'
    },
    BoxCommentsModal: {
      width: '95%',
      marginLeft: '15px'
    }
  })
